var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHakolavIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.9 120.5",
    style: {
      enableBackground: "new 0 0 113.9 120.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    x: 54,
    y: 28.8,
    className: "st0",
    width: 5.9,
    height: 15.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    className: "st0",
    d: "M59.3,38v-9.2c5.4,0,9.8-4.4,9.8-9.8s-4.4-9.8-9.8-9.8c-3.2,0-6.2,1.5-8,4.1L43.8,8 c6.1-8.6,17.9-10.6,26.5-4.6S80.9,21.4,74.9,30C71.3,35,65.5,38,59.3,38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    className: "st0",
    d: "M74.7,120.5v-9.2c16.6,0,30-13.5,30-30c0-13.6-8.2-28.8-26.3-29.8L0,51.2L0,42l78.7,0.2 c20.8,1.2,35.2,17.2,35.2,39C113.9,102.9,96.3,120.5,74.7,120.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14_00000148629036045188755990000000250721756282484132_",
    y: 0,
    className: "st1",
    width: 113.9,
    height: 120.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHakolavIconWhite);
export default __webpack_public_path__ + "static/media/HakolavIconWhite.c3ca2c06b4c2d094cd884d0079bc8861.svg";
export { ForwardRef as ReactComponent };